import {
    tss,
} from 'app/tss'

export default tss.create({
    wrapper: {
        width: '100%',
    },
    input: {
        width: '100%',
        height: '100%',
        padding: 0,
        border: '0 !important',
        margin: 0,
        '&:focus': {
            outline: 'none !important',
        },
    },
})
